"use strict";

var _taggedTemplateLiteral = require("/codebuild/output/src213846038/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _regeneratorRuntime = require("/codebuild/output/src213846038/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/regenerator/index.js");

var _slicedToArray = require("/codebuild/output/src213846038/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var react_1 = __importStar(require("react"));

var react_2 = require("@emotion/react");

var frontend_layout_1 = require("@ryerson/frontend.layout");

var frontend_theme_1 = require("@ryerson/frontend.theme");

var frontend_application_1 = require("@ryerson/frontend.application");

var frontend_typography_1 = require("@ryerson/frontend.typography");

var frontend_form_controls_1 = require("@ryerson/frontend.form-controls");

var gatsby_1 = require("gatsby");

var locationMenuData_1 = require("../Helpers/locationMenuData");

var frontend_common_1 = require("@ryerson/frontend.common");

var StaticItem_1 = __importDefault(require("../../common/StaticItem"));

var Utils_1 = require("../Helpers/Utils");

var StyledComponents_1 = require("../Helpers/StyledComponents");

var StyledComponents_2 = require("../../Renderers/StyledComponents"); // Begin Renderers Imports


var ShoppingListMenuRenderer_1 = require("../../Renderers/ShoppingListMenuRenderer");

var PhoneLinkRenderer_1 = require("../../Renderers/PhoneLinkRenderer");

var ShoppingCartRenderer_1 = require("../../Renderers/ShoppingCartRenderer");

var LoginButtonRenderer_1 = require("../../Renderers/LoginButtonRenderer");

var UtilityMenusRenderer_1 = require("../../Renderers/UtilityMenusRenderer");

var ProductMenuRenderer_1 = require("../../Renderers/ProductMenuRenderer");

var GlobalMenusRenderer_1 = require("../../Renderers/GlobalMenusRenderer");

var LogoRenderer_1 = require("../../Renderers/LogoRenderer");

var util_1 = require("../../common/util");

var SearchResults_1 = require("../../SearchResults");

var frontend_common_2 = require("@ryerson/frontend.common");

var frontend_application_2 = require("@ryerson/frontend.application");

var FullStructuredHeader_1 = require("../FullStructuredHeader");

var HeaderConfig_1 = require("../../common/HeaderConfig/HeaderConfig");

var util_2 = require("../../common/Contentful/util");

var common_permissions_1 = require("@ryerson/common.permissions");

var frontend_e_commerce_1 = require("@ryerson/frontend.e-commerce");

var frontend_common_3 = require("@ryerson/frontend.common");

var frontend_notification_1 = require("@ryerson/frontend.notification");

var alertData_1 = require("../Helpers/alertData");

var SearchResults_v2_1 = require("../../SearchResults_v2");

var SearchResultsContext_v2_1 = require("../../SearchResults_v2/SearchResultsContext_v2");

var FullHeaderDesktop = function FullHeaderDesktop(_ref) {
  var headerData = _ref.headerData,
      isSticky = _ref.isSticky,
      locationData = _ref.locationData,
      contentElementStyle = _ref.contentElementStyle,
      _ref$layerIndex = _ref.layerIndex,
      layerIndex = _ref$layerIndex === void 0 ? frontend_common_1.IndexedLayers.header : _ref$layerIndex,
      storeDirectory = _ref.storeDirectory,
      companyName = _ref.companyName;

  var _ref2 = (0, frontend_application_1.useApplication)(),
      axiosInstance = _ref2.axiosInstance,
      _ref2$localization = _ref2.localization,
      country = _ref2$localization.country,
      language = _ref2$localization.language,
      setLocalization = _ref2.setLocalization,
      _ref2$user = _ref2.user,
      isLoggedIn = _ref2$user.isLoggedIn,
      _ref2$user$token = _ref2$user.token,
      token = _ref2$user$token === void 0 ? "" : _ref2$user$token,
      _ref2$user$account = _ref2$user.account,
      account = _ref2$user$account === void 0 ? "" : _ref2$user$account,
      location = _ref2.location,
      zipCode = _ref2.zipCode;

  var headerSettings = HeaderConfig_1.headerConfigData[companyName];

  var _ref3 = (0, frontend_e_commerce_1.useEcommerce)(),
      shoppingCart = _ref3.shoppingCart,
      defaultShipToAddress = _ref3.defaultShipToAddress,
      selectedShipToAddress = _ref3.selectedShipToAddress;

  var _ref4 = (0, frontend_theme_1.useTheme)(),
      theme = _ref4.theme;

  var _ref5 = (0, frontend_application_1.useNotifications)(),
      notifications = _ref5.notifications;

  var _theme$colors$primary = theme.colors.primary,
      secondaryBrand = _theme$colors$primary.secondaryBrand,
      lightGray = _theme$colors$primary.lightGray,
      gray = _theme$colors$primary.gray,
      darkGray = _theme$colors$primary.darkGray; // Refs

  var _ref6 = (0, react_1.useState)({}),
      _ref7 = _slicedToArray(_ref6, 1),
      domNodeRefs = _ref7[0];

  var getDomNodeRef = function getDomNodeRef(fieldName) {
    domNodeRefs[fieldName] = react_1.default.createRef();
    return domNodeRefs[fieldName];
  };

  var mobileBreakPoint = language === "fr" ? 1070 : 1050; //	Menus and Popover states

  var menuDimmerStyle = react_1.default.useRef(""); // stores the current style on main container

  var _ref8 = (0, react_1.useState)(false),
      _ref9 = _slicedToArray(_ref8, 2),
      isCartExpanded = _ref9[0],
      setIsCartExpanded = _ref9[1];

  var _ref10 = (0, react_1.useState)(""),
      _ref11 = _slicedToArray(_ref10, 2),
      selectedProductMenuId = _ref11[0],
      setSelectedProductMenuId = _ref11[1];

  var _ref12 = (0, react_1.useState)(""),
      _ref13 = _slicedToArray(_ref12, 2),
      openUtilMenu = _ref13[0],
      setOpenUtilMenu = _ref13[1];

  var _react_1$default$useS = react_1.default.useState(false),
      _react_1$default$useS2 = _slicedToArray(_react_1$default$useS, 2),
      isPopoverExpanded = _react_1$default$useS2[0],
      setIsPopoverExpanded = _react_1$default$useS2[1];

  var _react_1$default$useS3 = react_1.default.useState(false),
      _react_1$default$useS4 = _slicedToArray(_react_1$default$useS3, 2),
      isShoppingListExpanded = _react_1$default$useS4[0],
      setIsShoppingListExpanded = _react_1$default$useS4[1];

  var _ref14 = (0, react_1.useState)(false),
      _ref15 = _slicedToArray(_ref14, 2),
      showSearchDropdown = _ref15[0],
      setShowSearchDropdown = _ref15[1]; // Permissions


  var UserPermissionUtil = new common_permissions_1.UserPermission(token);
  var permissionCart = UserPermissionUtil.has(common_permissions_1.Permission.Cart_View_Edit);
  var permissionShoppingList = UserPermissionUtil.has(common_permissions_1.Permission.Shopping_List_View_Edit); // Begin Sticky Mode Header Code

  var windowSize = (0, frontend_common_1.useWindowSize)();
  var windowScroll = (0, frontend_common_1.useWindowScroll)();
  var scrollMax = 50;
  var stickyBreakPoint = parseInt(theme.breakpoints.lg); // Determine if the header is Sticky

  isSticky.current = react_1.default.useMemo(function () {
    return (0, Utils_1.isStickyMode)(windowSize, windowScroll, scrollMax, stickyBreakPoint);
  }, [windowSize, windowScroll]); // Manage Sticky Attributes of Elements

  react_1.default.useMemo(function () {
    return (0, Utils_1.manageStickyAttributes)(isSticky, contentElementStyle, windowScroll, scrollMax, domNodeRefs, closeAllMenus);
  }, [windowScroll]); // Search Results

  var _ref16 = (0, react_1.useState)(),
      _ref17 = _slicedToArray(_ref16, 2),
      searchResults = _ref17[0],
      setSearchResults = _ref17[1];

  var _ref18 = (0, react_1.useState)(frontend_common_1.withTranslation.searchPlaceHolder[language]),
      _ref19 = _slicedToArray(_ref18, 2),
      searchPlaceHolderText = _ref19[0],
      setSearchPlaceHolderText = _ref19[1]; // Menu Content State


  var _ref20 = (0, react_1.useState)([]),
      _ref21 = _slicedToArray(_ref20, 2),
      countryMenuItems = _ref21[0],
      setCountryMenuItems = _ref21[1];

  var _ref22 = (0, react_1.useState)([]),
      _ref23 = _slicedToArray(_ref22, 2),
      languageMenuItems = _ref23[0],
      setLanguageMenuItems = _ref23[1];

  var _ref24 = (0, react_1.useState)((0, locationMenuData_1.getLocationData)(language, country, locationData)),
      _ref25 = _slicedToArray(_ref24, 2),
      locationMenuData = _ref25[0],
      setLocationMenuData = _ref25[1]; // Search States


  var _ref26 = (0, react_1.useState)(""),
      _ref27 = _slicedToArray(_ref26, 2),
      searchText = _ref27[0],
      setSearchText = _ref27[1];

  var debouncedSearchTerm = (0, frontend_common_1.useDebounce)(searchText.toString(), 500);

  var _ref28 = (0, react_1.useState)(""),
      _ref29 = _slicedToArray(_ref28, 2),
      displaySearchText = _ref29[0],
      setDisplaySearchText = _ref29[1];

  var _ref30 = (0, react_1.useState)(),
      _ref31 = _slicedToArray(_ref30, 2),
      keywordSearchResults = _ref31[0],
      setKeywordSearchResults = _ref31[1];

  var _ref32 = (0, react_1.useState)(false),
      _ref33 = _slicedToArray(_ref32, 2),
      isKeywordSearch = _ref33[0],
      setIsKeywordSearch = _ref33[1];

  var searchInputContainerRef = (0, react_1.useRef)(null);
  var searchResultsRef = (0, react_1.useRef)(null);
  var searchKeywordsMap = (0, Utils_1.getSearchKeywordsConfig)(storeDirectory)[language];
  var keywords = Object.keys(searchKeywordsMap); // Search Results State

  var handleSearchIconClicked = function handleSearchIconClicked() {
    setDisplaySearchText("");
    setSearchText("");
    resetSearchResultsToDefault();
  };

  var resetSearchResultsToDefault = function resetSearchResultsToDefault() {
    setShowSearchDropdown(false);
    setSearchResults(undefined);
    setKeywordSearchResults(undefined);
    setIsKeywordSearch(false);
  };

  var handleSearchInputKeyUp = function handleSearchInputKeyUp(event) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _keywordSearchResults, keyword, _keywordSearchResults2, payload, _ref34, _ref34$sessionItem, sessionItemKey, _ref34$dashboardUrl, dashboardUrl;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(event.key === "Enter" || event.keyCode === 13)) {
                _context.next = 13;
                break;
              }

              if (!(isKeywordSearch && keywordSearchResults)) {
                _context.next = 8;
                break;
              }

              _keywordSearchResults = keywordSearchResults.keyword, keyword = _keywordSearchResults === void 0 ? "" : _keywordSearchResults, _keywordSearchResults2 = keywordSearchResults.payload, payload = _keywordSearchResults2 === void 0 ? "" : _keywordSearchResults2;
              _ref34 = (0, Utils_1.getKeywordSessionItem)(keyword, storeDirectory), _ref34$sessionItem = _ref34.sessionItem, sessionItemKey = _ref34$sessionItem === void 0 ? "" : _ref34$sessionItem, _ref34$dashboardUrl = _ref34.dashboardUrl, dashboardUrl = _ref34$dashboardUrl === void 0 ? "" : _ref34$dashboardUrl;
              payload.length && sessionStorage.setItem(sessionItemKey, payload);
              (0, gatsby_1.navigate)(dashboardUrl);
              _context.next = 13;
              break;

            case 8:
              sessionStorage.setItem(frontend_common_1.SessionItems.displaySearchText, displaySearchText.toString());
              _context.next = 11;
              return (0, gatsby_1.navigate)("".concat(storeDirectory, "/search"));

            case 11:
              setSearchText("");
              setDisplaySearchText("");

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
  };

  var showMoreProducts_v2 = function showMoreProducts_v2() {
    sessionStorage.setItem(frontend_common_1.SessionItems.displaySearchText, displaySearchText.toString());
    return "".concat(storeDirectory, "/search");
  }; // Set Location Menu Data


  react_1.default.useEffect(function () {
    setLocationMenuData((0, locationMenuData_1.getLocationData)(language, country, locationData));
    setLanguageMenuItems([{
      items: Object.keys(frontend_application_1.Language).map(function (key) {
        return {
          value: key,
          active: true,
          display: frontend_common_1.withTranslation[key][language]
        };
      })
    }]);
    setCountryMenuItems([{
      items: Object.keys(frontend_application_1.Country).map(function (key) {
        return {
          value: key,
          active: true,
          display: (0, Utils_1.wrapOptionDisplay)(key, frontend_common_1.withTranslation[key][language], gray)
        };
      })
    }]);
    setSearchPlaceHolderText(frontend_common_1.withTranslation.searchPlaceHolder[language]);
  }, [language, country]);

  function closeAllMenus() {
    openUtilMenu && setOpenUtilMenu("");
    selectedProductMenuId && setSelectedProductMenuId("");
    isPopoverExpanded && setIsPopoverExpanded(false);
    isShoppingListExpanded && setIsShoppingListExpanded(false);
    !showSearchDropdown && setBackDimmed(false);
  } //Checks if account menu open


  react_1.default.useMemo(function () {
    if (isPopoverExpanded || isShoppingListExpanded) {
      setOpenUtilMenu("");
      setSelectedProductMenuId("");
    }
  }, [isPopoverExpanded, isShoppingListExpanded]);
  (0, frontend_common_2.useOnClickOutside)([searchInputContainerRef, searchResultsRef], function () {
    return setShowSearchDropdown(false);
  }); // Header search

  (0, react_1.useEffect)(function () {
    var _a;

    var searchTermLength = (_a = searchText === null || searchText === void 0 ? void 0 : searchText.toString().trim().length) !== null && _a !== void 0 ? _a : 0;

    if (searchTermLength < FullStructuredHeader_1.HEADER_SEARCH_MIN_LENGTH) {
      resetSearchResultsToDefault();
    }

    if (searchTermLength >= FullStructuredHeader_1.HEADER_SEARCH_MIN_LENGTH && debouncedSearchTerm === searchText) {
      var searchWords = searchText.toString().trim().toLowerCase().split(" ");

      if (keywords.includes(searchWords[0])) {
        setIsKeywordSearch(true);
        setSearchResults(undefined);
        setShowSearchDropdown(true);
        setKeywordSearchResults({
          keyword: searchWords[0],
          payload: searchWords.length > 1 ? searchWords.slice(1).join(" ") : ""
        });
      } else {
        setIsKeywordSearch(false);
        setKeywordSearchResults(undefined);
        var searchPhrase = searchText.toString().trim();
        var params = {
          "search-phrase": searchPhrase,
          language: language,
          limit: FullStructuredHeader_1.HEADER_SEARCH_LIMIT,
          "zip-code": !isLoggedIn ? zipCode : (0, frontend_common_1.formatZipCode)(selectedShipToAddress ? selectedShipToAddress.zipCode : (defaultShipToAddress === null || defaultShipToAddress === void 0 ? void 0 : defaultShipToAddress.zipCode) || zipCode)
        };
        var searchEventParams = {
          action: "browse",
          value: searchPhrase
        };
        axiosInstance.get(frontend_common_1.ApiUrl.GLOBAL_SEARCH_V2, {
          params: params,
          paramsSerializer: util_2.encodeSearchQueryParams
        }).then(function (response) {
          var responseData = response === null || response === void 0 ? void 0 : response.data;

          if (responseData) {
            setSearchResults(responseData);
            setShowSearchDropdown(true);
          } else {// setIsError(true);
          }

          (0, frontend_common_1.sendGAEvent)(frontend_common_1.GoogleAnalyticsEventName.ITEM_SEARCH, searchEventParams);
        }).catch(function () {//setIsError(true);
        });
      }
    }
  }, [debouncedSearchTerm, searchText]);
  (0, react_1.useEffect)(function () {
    resetSearchResultsToDefault();
    setDisplaySearchText("");
    setSearchText("");
  }, [language]);
  (0, react_1.useEffect)(function () {
    if (account) {
      resetSearchResultsToDefault();
    }
  }, [account]); // Dimming the background (opacity of main content container )

  function setBackDimmed(backDimmed) {
    var _a;

    var contentEl = typeof document !== "undefined" && (document === null || document === void 0 ? void 0 : document.querySelector("#root"));

    if (contentEl) {
      var currContainerStyle = (_a = contentEl.getAttribute("style")) === null || _a === void 0 ? void 0 : _a.trim();
      var containerHasStyle = !!((currContainerStyle === null || currContainerStyle === void 0 ? void 0 : currContainerStyle.length) > 0);
      var isAlreadyDimmed = !!(containerHasStyle && (currContainerStyle === null || currContainerStyle === void 0 ? void 0 : currContainerStyle.match(/opacity/)));
      containerHasStyle && (currContainerStyle = "".concat(currContainerStyle, ";"));

      if (backDimmed && !isAlreadyDimmed) {
        menuDimmerStyle.current = currContainerStyle || "";
        (0, Utils_1.setStyleOfElement)(contentEl, "".concat(menuDimmerStyle.current, "opacity:.5;"));
      } else if (!backDimmed && isAlreadyDimmed) {
        (0, Utils_1.setStyleOfElement)(contentEl, menuDimmerStyle.current);
      }
    }
  } //  Implement Background Dimming - when any menu is open


  react_1.default.useEffect(function () {
    if (isPopoverExpanded || openUtilMenu || selectedProductMenuId || isShoppingListExpanded) {
      setBackDimmed(true);
    } else {
      setBackDimmed(false);
    }
  }, [isPopoverExpanded, openUtilMenu, selectedProductMenuId, isShoppingListExpanded]); //Hook To Disable Boy Scrolling when Search Drop Down is active

  (0, react_1.useEffect)(function () {
    setBackDimmed(showSearchDropdown);
  }, [showSearchDropdown]);
  (0, frontend_common_3.useBodyScrollDisable)(showSearchDropdown); // Manage Padding on Content Area, inserted during Sticky Mode
  // Note: This assumes header is in fresnel parent container

  react_1.default.useEffect(function () {
    var _a;

    var fresnelWrapper = (_a = document === null || document === void 0 ? void 0 : document.querySelector(".header-desktop")) === null || _a === void 0 ? void 0 : _a.parentElement;
    fresnelWrapper && (0, Utils_1.setStyleOfElement)(fresnelWrapper, "position:relative;z-index:".concat(layerIndex || frontend_common_1.IndexedLayers.modal, ";"));
  }, []);

  var bodyClicked = function bodyClicked(event) {
    var elem = event === null || event === void 0 ? void 0 : event.target; // check to see if user didn't click on another utility or product menu
    // & send click, otherwise just close current if open

    var utilMenu, productMenu, popoverMenu;

    for (; elem && elem !== document; elem = elem === null || elem === void 0 ? void 0 : elem.parentNode) {
      elem.matches(".utility-menu-root") && (utilMenu = elem);
      elem.matches(".product-menu-root") && (productMenu = elem);
      elem.matches(".popover-menu-root") && (popoverMenu = elem);
    }

    utilMenu ? utilMenu.click() : setOpenUtilMenu("");
    productMenu ? productMenu.click() : setSelectedProductMenuId("");
    popoverMenu ? popoverMenu.click() : setIsPopoverExpanded(false);
    popoverMenu ? popoverMenu.click() : setIsShoppingListExpanded(false);
    bodyUnbindClick(bodyClicked);
  };

  var bodyBindClick = function bodyBindClick(func) {
    var _a;

    (_a = document === null || document === void 0 ? void 0 : document.querySelector("body")) === null || _a === void 0 ? void 0 : _a.addEventListener("click", func);
  };

  var bodyUnbindClick = function bodyUnbindClick(func) {
    var _a;

    (_a = document === null || document === void 0 ? void 0 : document.querySelector("body")) === null || _a === void 0 ? void 0 : _a.removeEventListener("click", func);
  };

  var getMenuObj = function getMenuObj(menuName) {
    var _a;

    return headerData && ((_a = headerData === null || headerData === void 0 ? void 0 : headerData.megaMenuHeaderMenus) === null || _a === void 0 ? void 0 : _a.find(function (obj) {
      return obj.label === menuName;
    }));
  };

  var doNavigation = function doNavigation(menuName) {
    var menObj = getMenuObj(menuName);
    menObj && menObj.active && (menObj === null || menObj === void 0 ? void 0 : menObj.value) && (0, gatsby_1.navigate)((0, util_1.getUrl)(menObj === null || menObj === void 0 ? void 0 : menObj.value));
    setOpenUtilMenu("");
    document && bodyUnbindClick(bodyClicked);
  };

  (0, react_1.useEffect)(function () {
    if ((notifications === null || notifications === void 0 ? void 0 : notifications.filter(function (notification) {
      return notification.type === frontend_application_2.NotificationsType.AddToCart;
    }).length) > 0) {
      setIsCartExpanded(true);
    } else {
      setIsCartExpanded(false);
    }
  }, [notifications]);
  return (0, jsx_runtime_1.jsxs)(StyledComponents_1.HeaderWrapper, {
    className: "header-desktop",
    isSticky: isSticky.current,
    stickyThreshold: scrollMax,
    fontFamily: theme.typography.fontFamilies.primary,
    children: [(0, jsx_runtime_1.jsx)(StyledComponents_1.UtilityNavigation, {
      backgroundColor: secondaryBrand,
      id: "utility-navigation",
      children: (0, jsx_runtime_1.jsx)(frontend_layout_1.Container, {
        vPadding: "0",
        hPadding: "0",
        children: (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
          alignItems: "center",
          style: (0, react_2.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\tpadding: 0 20px;\n\t\t\t\t\t\t"]))),
          children: [(0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
            grow: 1,
            children: (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
              alignItems: "center",
              children: [(0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
                style: (0, react_2.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t\t\tflex-wrap: no-wrap;\n\t\t\t\t\t\t\t\t\t\tflex-shrink: 0;\n\t\t\t\t\t\t\t\t\t"]))),
                children: (0, PhoneLinkRenderer_1.renderPhoneLink)(headerSettings, country)
              }), (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
                style: StyledComponents_1.borderWidth,
                css: (0, StyledComponents_1.dividerStyle)(mobileBreakPoint),
                children: (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
                  justifyContent: "center",
                  children: (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
                    breakPoint: mobileBreakPoint,
                    size: "sm",
                    color: lightGray,
                    children: "\u2502"
                  })
                })
              }), (0, UtilityMenusRenderer_1.renderUtilityMenus)(language, location, country, theme, mobileBreakPoint, languageMenuItems, countryMenuItems, locationMenuData, openUtilMenu, setOpenUtilMenu, setLocalization, bodyBindClick, bodyUnbindClick, bodyClicked, headerSettings, storeDirectory)]
            })
          }), (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
            className: "link-buttons-outer",
            css: (0, react_2.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t@media only screen and (max-width: ", "px) {\n\t\t\t\t\t\t\t\t\tflex-grow: 1;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t"])), mobileBreakPoint),
            children: (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
              className: "all-links-buttons-inner",
              alignItems: "center",
              css: (0, StyledComponents_1.linkButtonStyle)(mobileBreakPoint, isSticky.current),
              children: [(0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
                className: "contact-us-container",
                style: (0, StyledComponents_2.utilityNavMenuItem)(mobileBreakPoint),
                children: (0, jsx_runtime_1.jsx)(StaticItem_1.default, {
                  breakPoint: mobileBreakPoint,
                  itemName: "contactUs",
                  color: lightGray
                })
              }), isLoggedIn && !isSticky.current && permissionShoppingList && (0, jsx_runtime_1.jsx)(ShoppingListMenuRenderer_1.ShoppingListMenu, {
                mobileBreakPoint: mobileBreakPoint,
                isShoppingListExpanded: isShoppingListExpanded,
                setIsShoppingListExpanded: setIsShoppingListExpanded,
                isSticky: isSticky,
                storeDirectory: storeDirectory
              }), !isLoggedIn && (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
                className: "sign-up-container",
                css: (0, StyledComponents_2.utilityNavMenuItem)(mobileBreakPoint, true),
                children: (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
                  size: "sm",
                  color: lightGray,
                  children: (0, jsx_runtime_1.jsx)(StaticItem_1.default, {
                    breakPoint: mobileBreakPoint,
                    itemName: "signUp",
                    color: lightGray
                  })
                })
              }), !isSticky.current && (0, jsx_runtime_1.jsx)("form", {
                children: (0, jsx_runtime_1.jsx)(LoginButtonRenderer_1.LoginButton, {
                  isPopoverExpanded: isPopoverExpanded,
                  setIsPopoverExpanded: setIsPopoverExpanded,
                  mobileBreakPoint: mobileBreakPoint,
                  isSticky: isSticky,
                  storeDirectory: storeDirectory
                })
              }), !isSticky.current && permissionCart && (0, jsx_runtime_1.jsx)(ShoppingCartRenderer_1.CartPopover, {
                mobileBreakPoint: mobileBreakPoint,
                setIsCartExpanded: setIsCartExpanded,
                isCartExpanded: isCartExpanded,
                notifications: notifications,
                storeDirectory: storeDirectory,
                shoppingCart: shoppingCart
              })]
            })
          })]
        })
      })
    }), (0, jsx_runtime_1.jsxs)(frontend_layout_1.Container, {
      vPadding: "0",
      children: [(0, jsx_runtime_1.jsxs)(StyledComponents_1.GlobalNavigation, {
        className: "global-navigation-outer",
        ref: getDomNodeRef("globalNavigation"),
        theme: theme,
        speed: 0,
        children: [(0, jsx_runtime_1.jsx)(frontend_layout_1.Container, {
          vPadding: "0",
          hPadding: "0",
          children: (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
            className: "global-navigation-inner",
            alignItems: "center",
            justifyContent: "space-between",
            style: StyledComponents_1.globalNavigationInner,
            css: (0, react_2.css)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t", "\n\t\t\t\t\t\t\t\t", "\n\t\t\t\t\t\t\t"])), isSticky.current && "margin:0px 20px 0px 20px;", isSticky.current && "height:50px;"),
            children: [(0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
              children: (0, LogoRenderer_1.LogoRenderer)({
                companyName: companyName,
                isSticky: isSticky,
                mobileBreakPoint: mobileBreakPoint
              })
            }), (0, jsx_runtime_1.jsxs)(frontend_layout_1.FlexItem, {
              grow: isSticky.current ? 0.9 : 1,
              itemRef: searchInputContainerRef,
              children: [(0, jsx_runtime_1.jsx)(StyledComponents_1.SearchBar, {
                isSticky: isSticky.current,
                id: "search-bar-container",
                children: account === "99" ? (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
                  justifyContent: "center",
                  children: (0, jsx_runtime_1.jsx)("div", {
                    style: {
                      backgroundColor: theme.colors.secondary.lightRed
                    },
                    children: (0, jsx_runtime_1.jsx)(frontend_notification_1.Alert, {
                      severity: "error",
                      outline: true,
                      size: "sm",
                      children: (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
                        color: theme.colors.primary.darkerGray,
                        weight: "bold",
                        size: "xs",
                        children: alertData_1.selectCustomer[language]
                      })
                    })
                  })
                }) : (0, jsx_runtime_1.jsx)(frontend_form_controls_1.SearchInput, {
                  id: "search-bar-input",
                  placeholder: searchPlaceHolderText,
                  icon: displaySearchText ? "close" : undefined,
                  shape: "rounded",
                  size: isSticky.current ? "sm" : "md",
                  iconPosition: "right",
                  value: displaySearchText,
                  onIconClick: displaySearchText ? handleSearchIconClicked : undefined,
                  onChange: function onChange(e) {
                    var value = e.target.value;
                    setSearchText(value);
                    setDisplaySearchText(value);
                  },
                  css: (0, StyledComponents_1.searchInputStyles)(mobileBreakPoint, theme, isSticky.current),
                  language: language,
                  onFocus: function onFocus() {
                    var searchResultItems = isKeywordSearch ? [keywordSearchResults === null || keywordSearchResults === void 0 ? void 0 : keywordSearchResults.keyword] : (searchResults === null || searchResults === void 0 ? void 0 : searchResults.matchingProducts) || [];
                    setShowSearchDropdown(searchResultItems.length > 0);
                  },
                  onKeyUp: function onKeyUp(event) {
                    return handleSearchInputKeyUp(event);
                  }
                })
              }), showSearchDropdown && isKeywordSearch && (keywordSearchResults === null || keywordSearchResults === void 0 ? void 0 : keywordSearchResults.keyword) ? (0, jsx_runtime_1.jsx)(SearchResults_1.KeywordSearchResults, {
                isMobile: false,
                isSticky: isSticky.current,
                results: keywordSearchResults,
                keywordsConfig: (0, Utils_1.getSearchKeywordsConfig)(storeDirectory)
              }) : showSearchDropdown && (searchResults === null || searchResults === void 0 ? void 0 : searchResults.matchingProducts) ? (0, jsx_runtime_1.jsx)(SearchResultsContext_v2_1.SearchResultsProvider, {
                results: searchResults,
                showMoreProducts: showMoreProducts_v2,
                isSticky: isSticky.current,
                isMobile: false,
                itemRef: searchResultsRef,
                storeDirectory: storeDirectory,
                isKeywordSearch: isKeywordSearch,
                setSearchText: setSearchText,
                children: (0, jsx_runtime_1.jsx)(SearchResults_v2_1.SearchResults_v2, {})
              }) : null]
            }), isSticky.current ? (0, jsx_runtime_1.jsxs)(react_1.default.Fragment, {
              children: [(0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
                className: "links-buttons-inner",
                alignItems: "center",
                css: (0, StyledComponents_1.linkButtonStyle)(mobileBreakPoint, isSticky.current),
                children: [(0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
                  style: StyledComponents_1.phoneLinkWrapperStyle,
                  children: (0, PhoneLinkRenderer_1.renderPhoneLink)(headerSettings, country)
                }), (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
                  style: StyledComponents_1.borderWidth,
                  css: (0, StyledComponents_1.dividerStyle)(mobileBreakPoint, isSticky.current),
                  children: (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
                    justifyContent: "center",
                    children: (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
                      breakPoint: mobileBreakPoint,
                      size: "sm",
                      color: lightGray,
                      children: "\u2502"
                    })
                  })
                }), (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
                  style: (0, StyledComponents_2.utilityNavMenuItem)(mobileBreakPoint, undefined, isSticky.current),
                  children: (0, jsx_runtime_1.jsx)(StaticItem_1.default, {
                    breakPoint: mobileBreakPoint,
                    itemName: "contactUs",
                    color: lightGray
                  })
                }), isLoggedIn && permissionShoppingList && (0, jsx_runtime_1.jsx)(ShoppingListMenuRenderer_1.ShoppingListMenu, {
                  mobileBreakPoint: mobileBreakPoint,
                  isShoppingListExpanded: isShoppingListExpanded,
                  setIsShoppingListExpanded: setIsShoppingListExpanded,
                  isSticky: isSticky,
                  storeDirectory: storeDirectory
                })]
              }), (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
                children: [(0, jsx_runtime_1.jsxs)("form", {
                  children: [(0, jsx_runtime_1.jsx)(LoginButtonRenderer_1.LoginButton, {
                    isPopoverExpanded: isPopoverExpanded,
                    setIsPopoverExpanded: setIsPopoverExpanded,
                    mobileBreakPoint: mobileBreakPoint,
                    isSticky: isSticky,
                    storeDirectory: storeDirectory
                  }), " "]
                }), permissionCart && (0, jsx_runtime_1.jsx)(ShoppingCartRenderer_1.CartPopover, {
                  mobileBreakPoint: mobileBreakPoint,
                  setIsCartExpanded: setIsCartExpanded,
                  isCartExpanded: isCartExpanded,
                  notifications: notifications,
                  storeDirectory: storeDirectory,
                  shoppingCart: shoppingCart
                })]
              })]
            }) : (0, GlobalMenusRenderer_1.renderHeaderMenus)(headerData.megaMenuHeaderMenus, mobileBreakPoint, windowSize, theme, getMenuObj, doNavigation, bodyClicked, bodyBindClick, bodyUnbindClick, gatsby_1.navigate, openUtilMenu, language, setOpenUtilMenu, setSelectedProductMenuId, headerSettings, storeDirectory)]
          })
        }), !isSticky.current && (0, jsx_runtime_1.jsx)(StyledComponents_1.FullWidthDivider, {
          color: darkGray
        })]
      }), (0, jsx_runtime_1.jsxs)(StyledComponents_1.ProductNavigation, {
        ref: getDomNodeRef("productNavigation"),
        theme: theme,
        children: [(0, jsx_runtime_1.jsx)(frontend_layout_1.Container, {
          hPadding: "0",
          vPadding: "0",
          children: (0, ProductMenuRenderer_1.renderStructuredProductMenus)(headerData.megaMenuProductMenus, StyledComponents_1.productNavigationInner, mobileBreakPoint, theme, setSelectedProductMenuId, setOpenUtilMenu, selectedProductMenuId, bodyBindClick, bodyUnbindClick, bodyClicked, isSticky.current)
        }), !isSticky.current && (0, jsx_runtime_1.jsx)(StyledComponents_1.FullWidthDivider, {
          color: darkGray
        })]
      })]
    }), selectedProductMenuId && (0, ProductMenuRenderer_1.renderSelectedStructuredProductMenu)(headerData.megaMenuProductMenus.filter(function (productMenu) {
      return productMenu.contentful_id === selectedProductMenuId;
    })[0], selectedProductMenuId, isSticky.current, storeDirectory)]
  });
};

exports.default = FullHeaderDesktop;